import React from 'react';
import { Segment, Header, Grid, Icon } from 'semantic-ui-react';

const KeyboardShortcuts = ({ formattedTime, thresholdReached, current_locale = 'en' }) => {
  // Localization data for all supported languages
  const translations = {
    en: {
      copy: 'Copy',
      paste: 'Paste',
      undo: 'Undo',
      redo: 'Redo',
      rotate: 'Rotate',
      flip: 'Flip',
      delete: 'Delete',
      move: 'Move'
    },
    ar: {
      copy: 'نسخ',
      paste: 'لصق',
      undo: 'تراجع',
      redo: 'إعادة',
      rotate: 'تدوير',
      flip: 'انعكاس',
      delete: 'حذف',
      move: 'تحريك'
    },
    de: {
      copy: 'Kopieren',
      paste: 'Einfügen',
      undo: 'Rückgängig',
      redo: 'Wiederholen',
      rotate: 'Drehen',
      flip: 'Spiegeln',
      delete: 'Löschen',
      move: 'Bewegen'
    },
    fr: {
      copy: 'Copier',
      paste: 'Coller',
      undo: 'Annuler',
      redo: 'Rétablir',
      rotate: 'Pivoter',
      flip: 'Retourner',
      delete: 'Supprimer',
      move: 'Déplacer'
    },
    es: {
      copy: 'Copiar',
      paste: 'Pegar',
      undo: 'Deshacer',
      redo: 'Rehacer',
      rotate: 'Rotar',
      flip: 'Voltear',
      delete: 'Eliminar',
      move: 'Mover'
    },
    tr: {
      copy: 'Kopyala',
      paste: 'Yapıştır',
      undo: 'Geri Al',
      redo: 'Yinele',
      rotate: 'Döndür',
      flip: 'Çevir',
      delete: 'Sil',
      move: 'Taşı'
    },
    th: {
      copy: 'คัดลอก',
      paste: 'วาง',
      undo: 'เลิกทำ',
      redo: 'ทำซ้ำ',
      rotate: 'หมุน',
      flip: 'พลิก',
      delete: 'ลบ',
      move: 'ย้าย'
    },
    mx: {
      copy: 'Copiar',
      paste: 'Pegar',
      undo: 'Deshacer',
      redo: 'Rehacer',
      rotate: 'Rotar',
      flip: 'Voltear',
      delete: 'Eliminar',
      move: 'Mover'
    }
  };

  // Get the correct translations based on locale, fallback to English
  const t = translations[current_locale] || translations['en'];

  // Regular shortcuts for two columns
  const columnShortcuts = [
    { key: '⌘ C', description: t.copy },
    { key: '⌘ V', description: t.paste },
    { key: '⌘ Z', description: t.undo },
    { key: '⌘ ⇧ Z', description: t.redo },
    { key: 'R', description: t.rotate },
    { key: 'F', description: t.flip },
    { key: 'D', description: t.delete }
  ];

  // Navigation shortcuts
  const navigationShortcuts = [
    { key: '↑ ↓ ← →', description: t.move }
  ];

  const ShortcutItem = ({ shortcut }) => (
    <div style={{ 
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '4px 8px',
      marginBottom: '2px'
    }}>
      <div style={{ 
        fontSize: '0.92em',
        color: '#eeeeee',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <code style={{ 
          backgroundColor: '#2d2d2d',
          padding: '2px 6px',
          borderRadius: '3px',
          minWidth: '40px',
          display: 'inline-block'
        }}>
          {shortcut.key}
        </code>
        <span>{shortcut.description}</span>
      </div>
    </div>
  );

  return (
    <Segment style={{ 
      padding: '10px',
      backgroundColor: '#1b1c1d', 
      border: '1px solid rgba(255,255,255,0.1)',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      msUserSelect: 'none'
    }}>
      <Header as="h4" style={{ 
        marginBottom: '8px', 
        color: '#ffffff',
        fontSize: '1em'
      }}>
        {l.Shortcuts}
      </Header>

      <div>
        {columnShortcuts.map((shortcut, index) => (
          <ShortcutItem key={index} shortcut={shortcut} />
        ))}
      </div>

      <div style={{ marginTop: '4px' }}>
        {navigationShortcuts.map((shortcut, index) => (
          <ShortcutItem key={index} shortcut={shortcut} />
        ))}
      </div>

      {/* Time display */}
      {window.location.hostname == 'localhost' && formattedTime && (
        <div style={{
          marginTop: '12px',
          padding: '8px',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#eeeeee',
          fontSize: '0.92em'
        }}>
          <Icon name='clock outline' style={{ marginRight: '5px' }} />
          <span>Time: {formattedTime}</span>
          {thresholdReached && (
            <span style={{ marginLeft: '5px', color: '#ffcc00' }}>
              <Icon name='exclamation triangle' />
            </span>
          )}
        </div>
      )}
    </Segment>
  );
};

export default KeyboardShortcuts;
